export const SAVE_QUOTATION_PAYLOAD = "SAVE_QUOTATION_PAYLOAD";
export const HYDRATE_QUOTATION_PAYLOAD = "HYDRATE_QUOTATION_PAYLOAD";
